module.exports = __webpack_public_path__ + "img/page.5bede424.png";